enum CommerceImageTypes {
  logo = 1,
  banner = 2,
  CloverBanner = 3,
  TicketLogo = 4,
}

export default CommerceImageTypes;
